import React, { FC, useState } from 'react';

import { FormText } from '../form';

interface FormInput {
  errorMessage?: string;
  fieldName: string;
  id: string;
  value: string;
}

const JOTFORM_URL = 'https://eu-submit.jotform.com/submit/242466364289063';
const requiredFields = ['name', 'email'];

export const ApplicationProcessForm: FC = () => {
  const [formSuccess, setFormSuccess] = React.useState<boolean | null>(null);

  const [form, setForm] = useState<{
    [key: string]: FormInput;
  }>({
    name: {
      value: '',
      errorMessage: '',
      fieldName: 'q3_fullName',
      id: 'input_3',
    },
    email: {
      value: '',
      errorMessage: '',
      fieldName: 'q4_email',
      id: 'input_4',
    },
  });

  const resetFormValues = () => {
    Object.keys(form).forEach((key) => {
      setForm((f) => ({
        ...f,
        [key]: {
          ...f[key],
          value: '',
        },
      }));
    });
  };

  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault();

    const invalidFields = requiredFields.filter((field) => {
      if (!form[field].value) {
        setForm((f) => ({
          ...f,
          [field]: {
            ...f[field],
            errorMessage: 'This field is required',
          },
        }));

        return true;
      }

      return false;
    });

    if (!invalidFields.length) {
      const formData = new FormData();

      Object.keys(form).forEach((key) => {
        formData.append(
          form[key].fieldName,
          JSON.stringify(form[key].value).replace(/"/g, ''),
        );
      });

      try {
        const response = await fetch(JOTFORM_URL, {
          method: 'POST',
          body: formData,
        });

        if (response.ok) {
          setFormSuccess(true);
          resetFormValues();
        } else {
          setFormSuccess(false);
          console.error('Form submission failed');
        }
      } catch (error) {
        setFormSuccess(false);
        console.error('An error occurred during form submission:', error);
      }
    }
  };

  return (
    <>
      {formSuccess === null && (
        <form onSubmit={handleSubmit}>
          <div className="how-to-proceed--card--form-fields">
            <FormText
              label="Full Name"
              value={form.name.value}
              required
              type="text"
              inputAttrs={{
                id: form.name.id,
                name: form.name.fieldName,
              }}
              errorMessage={form.name.errorMessage}
              onChange={(value) => {
                setForm((f) => ({
                  ...f,
                  name: {
                    value,
                    errorMessage: '',
                    fieldName: form.name.fieldName,
                    id: form.name.id,
                  },
                }));
              }}
            />
            <FormText
              label="Company Email"
              value={form.email.value}
              required
              type="email"
              inputAttrs={{
                id: form.email.id,
                name: form.email.fieldName,
              }}
              errorMessage={form.email.errorMessage}
              onChange={(value) => {
                setForm((f) => ({
                  ...f,
                  email: {
                    value,
                    errorMessage: '',
                    fieldName: form.email.fieldName,
                    id: form.email.id,
                  },
                }));
              }}
            />
          </div>

          <div className="how-to-proceed--card--btn-wrapper">
            <button
              type="submit"
              className="link link_full link_blue how-to-proceed--card--btn"
              data-title="Start"
            >
              <span>Start</span>
            </button>
          </div>
        </form>
      )}
      {formSuccess && (
        <div className="how-to-proceed--card--message">
          Thank You!
          <br />
          <br />
          Your submission has been received.
        </div>
      )}
      {formSuccess === false && (
        <div className="how-to-proceed--card--message">
          There was an error, please try again later.
        </div>
      )}
    </>
  );
};
